// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\StandardItem\ApiStandardItem.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { BillingSystem, BillingSystemData, BillingSystemOptions } from 'data/models/BillingSystem';
import { QuickBooksInventoryItemTracking, QuickBooksInventoryItemTrackingData, QuickBooksInventoryItemTrackingOptions } from 'data/models/QuickBooksInventoryItemTracking';
import { Rate, RateData, RateOptions } from 'data/models/Rate';
import { StandardItemType, StandardItemTypeData, StandardItemTypeOptions } from 'data/models/StandardItemType';

// StandardItemData is the class that StandardItem serializes to/from
export interface StandardItemData {
    Id : number;
	
    BillingSystem : BillingSystemData | null;
    BillingSystemId : number;
    Rates : RateData[] | null;
    Type : StandardItemTypeData | null;
    TypeId : /* GUID */ string | null;
	
    Description : string | null;
    Name : string | null;
    QBTracking : QuickBooksInventoryItemTrackingData;
}

// StandardItemOptions is the class which may be passed to the StandardItem constructor to define optional initial data values
export interface StandardItemOptions {
    Id : number;
	
    BillingSystem? : BillingSystemOptions | null;
    BillingSystemId? : number;
    Rates? : RateOptions[] | null;
    Type? : StandardItemTypeOptions | null;
    TypeId? : /* GUID */ string | null;
	
    Description? : string | null;
    Name? : string | null;
    QBTracking? : QuickBooksInventoryItemTrackingOptions;
}

export class StandardItem {
    public Id : DataSignal<number>;
	
    public BillingSystem : DataSignal<BillingSystem | null>;
    public BillingSystemId : DataSignal<number>;
    public Rates : SDataArray<Rate>;
    public Type : DataSignal<StandardItemType | null>;
    public TypeId : DataSignal<string | null>;
	
    public Description : DataSignal<string | null>;
    public Name : DataSignal<string | null>;
    public QBTracking : QuickBooksInventoryItemTracking;

    constructor();
    constructor(data : StandardItemOptions);
    constructor(data: StandardItemOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.BillingSystem = S.value<BillingSystem | null>(null);
        this.BillingSystemId = jsonableObservable(S.value<number>(data && data.BillingSystemId !== undefined ? data.BillingSystemId : 0));
        this.Rates = SArray<Rate>([]);
        this.Type = S.value<StandardItemType | null>(null);
        this.TypeId = jsonableObservable(S.value<string | null>(data && data.TypeId !== undefined ? data.TypeId : null));
	    
        this.Description = jsonableObservable(S.value<string | null>(data && data.Description !== undefined ? data.Description : null));
        this.Name = jsonableObservable(S.value<string | null>(data && data.Name !== undefined ? data.Name : null));
        this.QBTracking = data && data.QBTracking !== undefined ? new QuickBooksInventoryItemTracking(data.QBTracking) : new QuickBooksInventoryItemTracking();
    }

    static key(obj : StandardItem) {
        return obj.Id();
    }
    
    static dataKey(obj : StandardItemOptions) {
        return obj.Id;
    }

    static update(obj : StandardItem, data : StandardItemOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
            if (data.BillingSystemId !== undefined) obj.BillingSystemId(data.BillingSystemId);
            if (data.TypeId !== undefined) obj.TypeId(data.TypeId);
	        
            if (data.Description !== undefined) obj.Description(data.Description);
            if (data.Name !== undefined) obj.Name(data.Name);
            if (data.QBTracking !== undefined) QuickBooksInventoryItemTracking.update(obj.QBTracking, data.QBTracking);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/StandardItem.ts